import { BehaviorSubject } from 'rxjs';
import { TeamUser } from '../../interfaces/team/TeamUser';
import { OwnerGraphTrend } from '../../Data/SD';

// subject for selecting header
export const selectedUserForTask$ = new BehaviorSubject<TeamUser[]>([]);

export const currentConversationId$ = new BehaviorSubject<number>(0);

// BehaviorSubject for the owner dashboard compilance graph change
export const ownerTrendSubjet$ = new BehaviorSubject<OwnerGraphTrend>(OwnerGraphTrend.Participants);

export const UpdateOnwerTrendSubject = (trend: OwnerGraphTrend) => {
    ownerTrendSubjet$.next(trend);
}



// Subject for the Header selected Region
export const selectedRegionIdFromHeader$ = new BehaviorSubject<number | null>(null);

export const UpdateSelectedRegionIdFromHeaderSubject = (regionId : number | null) =>{
    selectedRegionIdFromHeader$.next(regionId);
}

// Subject for the selected Waiver type from header
export const selectWaiverTypeIdFromHeader$ = new BehaviorSubject<number | null>(null);

export const UpdateSelectedWaiverIdFromHeaderSubject = (waiverId : number | null) =>{
    selectWaiverTypeIdFromHeader$.next(waiverId);
}

